// extracted by mini-css-extract-plugin
export var cardHeader = "_si-0";
export var reorderHandle = "_si-3";
export var titleArea = "_si-1";
export var titleAreaWithHandle = "_si-2";